/**
 * As perguntas da Central de ajuda (2026-10-15).
 *
 * Cada resposta descreve uma REGRA do produto que já está no código
 * (`CLAUDE.md`, "Regras de negócio confirmadas"). Quando a regra mudar, a
 * resposta muda junto: um FAQ que contradiz a tela é pior do que nenhum.
 */

export type FaqEntry = { question: string; answer: string };

export const HELP_FAQ: FaqEntry[] = [
  {
    question: "Por que uma linha da minha planilha não virou menção?",
    answer:
      "Linha com veículo ou canal que a empresa ainda não cadastrou vai para a fila de correção do upload, agrupada por veículo/canal: um cadastro resolve o grupo inteiro. Linha em que nenhuma marca foi encontrada também vai para a fila, para completar o texto e reprocessar, ou descartar se não for sobre a empresa. Já veículo ou canal marcado como ignorado no cadastro é pulo, não pendência."
  },
  {
    question: "O upload foi recusado como template ou arquivo inválido. O que faço?",
    answer:
      "Template inválido quer dizer que as colunas não batem com o modelo da clipadora escolhida: confira se o arquivo é o export certo. Arquivo inválido quer dizer que ele não pôde ser lido como planilha (outro formato, compactado ou grande demais ao descompactar). Nos dois casos nada foi gravado, e é só enviar de novo o arquivo certo."
  },
  {
    question: "Corrigi a classificação de uma menção. O CENA muda?",
    answer:
      "Sim. A correção recalcula o CENA da menção na hora, e o histórico guarda quem mudou o quê. O que não muda são as amostras já geradas (veja a próxima pergunta)."
  },
  {
    question: "Por que a amostra não mudou depois das minhas correções?",
    answer:
      "Amostra é uma foto congelada das menções no momento em que foi gerado, e o número aprovado é o que fica. Para ver as correções, gere uma amostra nova com o mesmo recorte."
  },
  {
    question: "Por que algumas menções aparecem \"sem nota\"?",
    answer:
      "Menção neutra só ganha nota quando a empresa tem um peso cadastrado para neutras. Sem esse peso ela fica sem nota (o que é diferente de nota zero), e amostras e dashboard mostram quantas ficaram assim ao lado da média."
  },
  {
    question: "Não vejo uma empresa, ou não consigo abrir uma tela.",
    answer:
      "O acesso a cada empresa vem de um vínculo direto ou do núcleo em que você está, e o seu papel define o que você pode fazer nela. Quem libera é o Administrador do seu núcleo ou um Máster. O seu papel e as empresas vinculadas aparecem em Meu perfil."
  },
  {
    question: "Por que não consigo editar o prompt ou o modelo de IA da empresa?",
    answer:
      "Prompt base e modelo por tarefa têm uma chave por empresa que só o Máster liga. Com ela desligada a tela mostra os campos só para leitura. Enquanto uma linha do prompt aparece como \"Segue o geral\", ela acompanha o prompt geral da instalação; com a chave ligada, quem edita usa \"Personalizar\" para dar à empresa um texto próprio naquela linha, e \"Voltar ao geral\" desfaz. Peça ao Máster se a empresa precisar de ajuste."
  },
  {
    question: "O que é o \"código de suporte\" que aparece nas mensagens de erro?",
    answer:
      "É o identificador daquele erro no registro do servidor: com ele o suporte acha exatamente o que aconteceu. O formulário de chamado desta página já oferece anexar o código do último erro que você viu."
  },
  {
    question: "Como troco minha senha?",
    answer:
      "Em Segurança, no menu da sua conta. Se você entra com a conta Google, a senha e a verificação em duas etapas são as do Google."
  }
];
